"use client";
import Image from "next/image";
import { useFormatter, useTranslations } from "next-intl";
import { useEffect, useState, useTransition } from "react";
import { ClaimVipBonus, GetVipBonusInfo, GetWalletBalance } from "@/lib/actions";
import { Button } from "@/components/custom";
import { toast } from "react-toastify";
import { useRouter } from "@/i18n/routing";

const VipBonusModal = () => {
  const router = useRouter();
  const t = useTranslations();
  const [claimableAmount, setClaimableAmount] = useState(0);
  const [currency, setCurrency] = useState("BDT");
  const [pending, startTransition] = useTransition();

  const ClaimHandler = () => {
    startTransition(() =>
      ClaimVipBonus()
        .then((res) => {
          console.log(res);
          if (res.status_code === 0) toast.success(t("vip-bonus-success"));
          else toast.error(t("vip-bonus-insufficient"));
          GetVipBonusInfo()
            .then((res) => {
              console.log(res);
              setClaimableAmount(res.data.claimable_amount);
            })
            .catch((err) => {
              console.log(err);
              toast.error(t("vip-bonus-fail"));
              setClaimableAmount(0);
            });
        })
        .catch((err) => {
          console.log(err);
          toast.error(t("vip-bonus-fail"));
        })
    );
  };

  useEffect(() => {
    startTransition(() => {
      GetWalletBalance()
        .then((res) => {
          console.log(res);
          setCurrency(res.currency);
        })
        .catch((err) => {
          console.log(err);
        });

      GetVipBonusInfo()
        .then((res) => {
          console.log(res);
          setClaimableAmount(res.data.claimable_amount);
        })
        .catch((err) => {
          console.log(err);
          toast.error(t("vip-bonus-fail"));
          setClaimableAmount(0);
        });
    });
  }, []);

  const format = useFormatter();

  return (
    <div className="flex flex-col gap-y-5 pb-5">
      <Image src="/promotion/banner10.png" width={500} height={500} alt="GIF" className="w-full" />
      {/* <Input
        label="Claimable VIP Bonus"
        labelPlacement="outside"
        size="lg"
        radius="sm"
        readOnly
        value={currency + " " + String(claimableAmount) + ".00"}
        classNames={{ input: "text-center" }}
      /> */}
      <div className="bg-gradient-to-r from-[#FFEA92] via-[#C9A04C] to-[#FFFFA5] bg-clip-text text-center text-[32px] font-black leading-none text-transparent drop-shadow-lg">
        {format.number(claimableAmount, {
          style: "currency",
          // notation: "compact",
          currency: "BDT",
          currencyDisplay: "symbol",
          currencySign: "standard",
        })}
      </div>
      <Button
        isDisabled={claimableAmount <= 0 || pending}
        onPress={() => {
          if (claimableAmount > 0) ClaimHandler();
          else toast.error(t("vip-bonus-insufficient"));
        }}
      >
        Claim Now
      </Button>
    </div>
  );
};

export default VipBonusModal;
